//git update-index --skip-worktree business_logic/local_constants.js
export const BASE_URL_LOCAL = 'http://localhost:8111/';
